import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AdPlanModerationWarnings = ({ violations }) => {
  const { t } = useTranslation(["advertising"]);
  // Handle validation errors that are sometimes saved as stringified object to only show message to user
  if (violations.includes(`"message":`)) {
    violations = violations?.split(`"message":"`)[1].split(`"}`)[0];
  }

  const violationCount = typeof violations === "string" ? 1 : violations.length;

  return (
    <Row>
      <Col xs={12} lg={8} className="pe-5">
        <p
          style={{
            color: "#73706E",
            fontWeight: "700",
            textTransform: "none",
            marginRight: "auto",
            cursor: "pointer",
          }}
          className="fs-standard"
          hidden={typeof violations === "string" && violations?.indexOf("awaiting") > -1}
        >
          {t(($) => $.advertising["Moderation failed due to the following violations:"], { count: violationCount })}
        </p>
        {typeof violations === "object" ?
          violations.map((violation) => (
            <div key={violation} className="pb-4">
              <small className="text-danger">{violation}</small>
            </div>
          ))
        : typeof violations === "string" ?
          <div className="pb-4">
            <small
              className={`text-${
                typeof violations === "string" && violations?.indexOf("awaiting") > -1 ? "warning" : "danger"
              }`}
            >
              {violations}
            </small>
          </div>
        : null}
      </Col>
    </Row>
  );
};

export default AdPlanModerationWarnings;
